import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a-label',
    templateUrl: './a-label.component.html',
    styleUrls: ['./a-label.component.scss'],
    standalone: false
})
export class ALabelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
